export default __webpack_public_path__ + "static/AppCV3-283f3cbeff82393326bf49c17ad4c99c.png";